
import EncountersTag from "./encounters-tag"
import { useSearch } from "@tanstack/react-router"
type SearchParams = {
  session_id?: string;
}

export default function EncountersCard ({session,handleEncounterSelect}:{session:any,handleEncounterSelect:(id:string)=>void}) {
    const { session_id } = useSearch({ from: "/(dashboard)/dashboard/urgent-care/encounters/" }) as SearchParams
    const isActive = session.session_id === session_id

    return (
        <div 
          onClick={() => handleEncounterSelect(session.session_id)} 
          role="button" 
          className={`border rounded-[12px] hover:border-[#04040466] border-[#0404041A] p-[20px] flex flex-col gap-[8px] transition-all ${
            isActive ? 'border-[#4272DD] bg-[#4272DD1A]' : ''
          }`}
        >
            <div className="flex items-center gap-2">
               <h1 className="text-[#1A202C] text-[18px] font-medium leading-[130%] tracking-[-1%]">{session?.diagnosis?.[0]?.disease_name ? session?.diagnosis?.[0]?.disease_name : `#${session?.session_number} Session`}</h1>
            </div>
            <div className="flex items-center gap-2">
                <span className="text-[#464B55] text-[14px] leading-[140%] font-normal tracking-[-1%]">Date:{session.start_datetime}</span>
            </div>
            <div className="flex flex-wrap items-center gap-[8px]">
            <EncountersTag type={session?.onboard_session ==='ended' && session?.alfie_session === 'ended' ? "":"in_progress"} />
            <EncountersTag type={session?.onboard_session ==='ended' && session?.alfie_session === 'ended' ? "Closed":"action_needed"} />
            <EncountersTag type={session.is_red_flagged === true ? "red_flagged" : ""} />
            <EncountersTag type={session.treatment_completed === true ? "treatment_completed" : ""} />
            </div>
        </div>
    )
}